
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/[key]",
      function () {
        return require("private-next-pages/guide/[key].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/[key]"])
      });
    }
  